import { isNumber } from '../utils';
var instances;
var componentInstanceIndexMap = new Map();
var actionInstanceIndexMap = new Map();
export function setActionInstanceIndex(key, instance) {
    return actionInstanceIndexMap.set(key, instance);
}
export function removeActionInstanceIndex(key) {
    return actionInstanceIndexMap.delete(key);
}
export function getActionInstanceIndex(key) {
    return actionInstanceIndexMap.get(key);
}
export function setComponentInstanceIndex(key, index, parentKey) {
    return componentInstanceIndexMap.set(key, { index: index, parentKey: parentKey });
}
export function removeComponentInstanceIndex(key) {
    return componentInstanceIndexMap.delete(key);
}
export function getComponentInstanceIndex(key) {
    return componentInstanceIndexMap.get(key);
}
export function generateChildIndexMap(children, parentKey, deleteKey) {
    var generateChildren = function (componentInstances, pKey) {
        componentInstances === null || componentInstances === void 0 ? void 0 : componentInstances.forEach(function (_a, index) {
            var key = _a.key, children = _a.children, actions = _a.actions;
            setComponentInstanceIndex(key, index, pKey);
            actions.forEach(function (action) {
                setActionInstanceIndex(action.key, action);
            });
            children && generateChildren(children, key);
        });
    };
    if (isNumber(deleteKey)) {
        removeComponentInstanceIndex(deleteKey);
    }
    generateChildren(children, parentKey);
}
export function generateComponentInstanceIndexMap(componentInstance) {
    componentInstanceIndexMap.clear();
    generateChildIndexMap(componentInstance);
}
export function initComponentInstanceIndexMap(componentInstances) {
    instances = componentInstances;
    generateComponentInstanceIndexMap(componentInstances);
}
export function getComponentInstance(key, componentInstances) {
    var _a;
    var iIndex = getComponentInstanceIndex(key);
    if (!iIndex) {
        return null;
    }
    var index = iIndex.index, parentKey = iIndex.parentKey;
    var ensureComponentInstances = componentInstances !== null && componentInstances !== void 0 ? componentInstances : instances;
    if (typeof parentKey === 'number') {
        var parent_1 = getComponentInstance(parentKey, ensureComponentInstances);
        return (_a = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.children) === null || _a === void 0 ? void 0 : _a[index];
    }
    return ensureComponentInstances[index];
}
//# sourceMappingURL=instanceMap.js.map